<template>
	<div>
		<h2>Propiedades</h2>

		<router-link :to="{name: 'agre-propi'}">Agregar</router-link>

		<ul id='propiedades-lista' v-if="propiedadesTodas !=null" >
			<li v-for="propi in propiedadesTodas">	

				<strong>{{propi.nombreCompleto}} {{propi.familia}} {{propi.tipo}}</strong>

  			</li>
		</ul>
		<span v-else>Cargando propiedades...</span>
	</div>
</template>



<script>
import axios from 'axios';

export default {
  name: 'Propiedades',
  mounted(){
  	this.getPropiedades();
  },
  data () {
    return {
      propiedadesTodas: null
    }
  },
  methods:{
  	getPropiedades(){
  		axios.get('https://www.directodo.com/Rentus/accesosdb/leePropiedades.php')
  		     .then((respuesta) => {
  		     	this.propiedadesTodas=respuesta.data;
  			 });
  	}
  }
}
</script>

<style lang="scss">
	#propiedades-lista{
		padding:20px;
		li{
			width: 30%;
			height: 120px;
			background: #eee;
			overflow: hidden;
		}
	}
</style>




// WEBPACK FOOTER //
// src/Propiedad-seleccionar.vue